var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurpleBag(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 51,
    viewBox: "0 0 43 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3649 1C10.9536 1 10.9787 2.82107 11.2927 3.73161C11.2927 7.65006 14.8721 11.0159 16.6619 12.209C3.92692 19.5938 0.931534 31.6757 1.02571 36.7935C0.422874 45.3086 10.5707 48.4421 15.7199 48.9445C27.0231 50.9791 35.061 47.0292 37.667 44.8C43.9214 39.7512 40.8284 31.0145 37.196 25.2077C33 18.5 26.4894 12.8998 23.1612 11.4555C25.5725 10.3252 27.6197 5.3329 28.3418 2.97806C28.7186 0.642065 26.8033 1 25.7986 1.47097L20.147 2.97806L19.3935 3.16645L18.2631 2.97806L13.3649 1Z",
    fill: "#9F509F",
    stroke: "black",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_23"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 51,
    fill: "purple"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleBag);
export default __webpack_public_path__ + "static/media/purple-bag.ac5f671405212c90c84035df3b1f0a00.svg";
export { ForwardRef as ReactComponent };